/* Alankar HP — interactions */
(function(){
  /* 1. Scroll fade-up via IntersectionObserver */
  function initFadeUp(){
    var els=document.querySelectorAll('.fade-up');
    if(!els.length)return;
    if(window.Shopify && window.Shopify.designMode){
      els.forEach(function(el){ el.classList.add('in-view'); });
      return;
    }
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          e.target.classList.add('in-view');
          io.unobserve(e.target);
        }
      });
    },{threshold:0.1,rootMargin:'0px 0px -40px 0px'});
    els.forEach(function(el){io.observe(el);});
  }

  /* 2. Category filter tabs — New Arrivals */
  function initFilterTabs(){
    document.querySelectorAll('.filters').forEach(function(bar){
      bar.querySelectorAll('.filter-tab').forEach(function(tab){
        tab.addEventListener('click',function(){
          var val=this.getAttribute('data-filter');
          bar.querySelectorAll('.filter-tab').forEach(function(t){t.classList.remove('active');});
          this.classList.add('active');
          var grid=bar.closest('.sect-inner');
          if(!grid)return;
          grid.querySelectorAll('.product-card').forEach(function(card){
            var cat=card.getAttribute('data-cat');
            card.style.display=(val==='all'||cat===val)?'':'none';
          });
        });
      });
    });
  }

  /* 3. Heritage counter animation */
  function initCounters(){
    var cards=document.querySelectorAll('[data-counter-card]');
    if(!cards.length)return;
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(!e.isIntersecting)return;
        io.unobserve(e.target);
        e.target.querySelectorAll('[data-target]').forEach(function(el){
          var target=parseInt(el.getAttribute('data-target'))||0;
          var suffix=el.getAttribute('data-suffix')||'';
          var dur=1800,t0=performance.now();
          (function tick(now){
            var p=Math.min((now-t0)/dur,1),ease=1-Math.pow(1-p,3);
            el.textContent=Math.round(target*ease)+suffix;
            if(p<1)requestAnimationFrame(tick);
          })(t0);
        });
      });
    },{threshold:0.3});
    cards.forEach(function(c){io.observe(c);});
  }

  /* 4. Add-to-bag cart handler — opens cart drawer via pcard.js global */
  function initAddToBag(){
    document.addEventListener('click',function(e){
      var btn=e.target.closest('.product-add');
      if(!btn)return;
      e.preventDefault();
      var variantId=btn.getAttribute('data-variant-id');
      if(!variantId)return;
      var orig=btn.innerHTML;
      btn.disabled=true;
      btn.textContent='Adding...';
      fetch('/cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
        body:JSON.stringify({id:parseInt(variantId,10),quantity:1})
      }).then(function(r){
        if(!r.ok){return r.json().then(function(d){throw new Error(d.description);});}
        return r.json();
      }).then(function(){
        btn.textContent='Added!';
        /* Open cart drawer — pcard.js exposes this globally */
        if(window.alkOpenCart){window.alkOpenCart();}
        return fetch('/cart.js').then(function(r){return r.json();});
      }).then(function(cart){
        /* Refresh cart UI */
        if(window.alkUpdateCart){window.alkUpdateCart(cart);}
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }).catch(function(err){
        btn.innerHTML=orig;
        console.error('Add to bag error:',err);
      }).finally(function(){
        setTimeout(function(){btn.innerHTML=orig;btn.disabled=false;},1600);
      });
    });
  }

  function init(){
    initFadeUp();
    initFilterTabs();
    initCounters();
    initAddToBag();
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',init);
  } else {
    init();
  }

  /* Shopify theme editor: re-init after section re-render */
  document.addEventListener('shopify:section:load',    function(){ init(); });
  document.addEventListener('shopify:section:reorder', function(){ init(); });
  document.addEventListener('shopify:section:select',  function(){ init(); });

})();
